import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';

function MessageConfirmationDialog({ message: Message, open, title, handleAction, handleClose }) {
  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby='responsive-dialog-title'>
        <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <Message />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='secondary' variant='contained'>
            Cancelar
          </Button>

          <Button
            onClick={() => {
              handleAction();
              handleClose();
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MessageConfirmationDialog;
